import 'angular:locale/data:es-CO';(globalThis.$localize ??= {}).locale = "es-CO";
